import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../../environments/environment";
import { CategoryService } from "../../../../modules/category/services/category.service";
import { UserService } from "../../../../modules/user/services/user.service";
import { CamerallaAuthService } from "../../../services/authentication-services/cameralla-auth.service";
import { PermissionAdminService } from "../../../services/guard-services/permission-admin.service";
import { WordpressService } from "../../../services/wordpress-services/wp.service";
// import $ from "jquery";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../../../core/modules/auth/services/auth.service";
import { AppService } from "../../../../core/services/app.service";
import { GlobalVariables } from "../../../models/cameralla-global.model";
// import { MailPopupComponent } from "../../../../modules/mail/components/mail-popup/mail-popup.component";
import { LanguageConstant } from "../../../constants/language-constant";
import { ConfigService } from "../../../services/config.service";

@Component({
  selector: "app-main-header",
  templateUrl: "./header.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  headerLink = environment["header_footer_link"];
  tagCollection = GlobalVariables.tag_collection;
  hrefPage: string;
  public static showPopup = false;
  userPreferredLanguage = null;
  public site = environment["site"];
  public prefixDomain = environment.prefixDomain;
  public ticketFeature = environment.ticketFeature;
  public inforWPMenus = [
    {
      content: "Clubs",
      contentNorway: "Photo clubs",
      url: "/user/my-groups",
      icon: "fa fa-users",
      order: 5,
      create_at: "2022-02-21T06:11:42.000Z",
      id: 7,
    },
  ];

  isAdmin: boolean = false;

  constructor(
    protected authService: AuthService,
    protected router: Router,
    protected categoryService: CategoryService,
    protected userService: UserService,
    protected camerallaAuthService: CamerallaAuthService,
    protected app: AppService,
    protected toastr: ToastrService,
    protected http: HttpClient,
    protected _modalService: NgbModal,
    protected cd: ChangeDetectorRef,
    protected wpService: WordpressService,
    protected configService: ConfigService
  ) {}

  localUserId;
  userInfo: any = {
    isCanon: false,
  };

  ngAfterViewInit() {
    // remove JQuery
    // $(document).ready(function () {
    //   setTimeout(() => {
    //     $(".navbar-toggler").click(function () {
    //       $(".slide-container").toggleClass("slide-active");
    //     });
    //   });
    // });
    setTimeout(() => {
      const navbarToggler = document.querySelector(".navbar-toggler");
      const slideContainer = document.querySelector(".slide-container");

      if (navbarToggler && slideContainer) {
        navbarToggler.addEventListener("click", () => {
          slideContainer.classList.toggle("slide-active");
        });
      }
    });
  }

  ngOnInit() {
    this.localUserId = +this.camerallaAuthService.getLocalUserInfo()["id"];
    console.log("this.localUserId", this.localUserId);
    this.userService.getPersonalDetails(this.localUserId).then((data) => {
      this.isAdmin = !!(data.role == PermissionAdminService.adminConst);
      this.userInfo = data;
      this.userPreferredLanguage = data.preferredLanguage
        ? data.preferredLanguage
        : LanguageConstant.NO;
      // Grant manage access for user mail: anne@kampsport.no
      if (
        !this.isAdmin &&
        data.isKampsport &&
        data.email == PermissionAdminService.otherAccess
      ) {
        this.isAdmin = true;
      }

      // Redirect to the upgrade page
      // Not show with English user

      if (
        data.accessLevel &&
        !data.memberships.includes("english") &&
        data.accessLevel.toLowerCase() != "fotoskolen"
      ) {
        this.redirectPage(data.accessLevel);
      }

      if (data.isCanon) {
        this.headerLink = environment["canon_header_footer_link"];
      } else {
        this.headerLink = environment["header_footer_link"];
      }
      setTimeout(() => {
        this.cd.markForCheck();
      }, 1000);
    });

    if (!this.localUserId) {
      this.userInfo = this.camerallaAuthService.getUserInfo();
      this.localUserId = this.userInfo.id;

      this.isAdmin = !!(
        this.userInfo.role == PermissionAdminService.adminConst
      );
      this.userInfo = this.userInfo;
      this.userPreferredLanguage = this.userInfo.preferredLanguage
        ? this.userInfo.preferredLanguage
        : LanguageConstant.NO;
      // Grant manage access for user mail: anne@kampsport.no
      if (
        !this.isAdmin &&
        this.userInfo.isKampsport &&
        this.userInfo.email == PermissionAdminService.otherAccess
      ) {
        this.isAdmin = true;
      }

      // Redirect to the upgrade page
      // Not show with English user

      if (
        this.userInfo.accessLevel &&
        !this.userInfo.memberships.includes("english") &&
        this.userInfo.accessLevel.toLowerCase() != "fotoskolen"
      ) {
        this.redirectPage(this.userInfo.accessLevel);
      }

      if (this.userInfo.isCanon) {
        this.headerLink = environment["canon_header_footer_link"];
      } else {
        this.headerLink = environment["header_footer_link"];
      }
      setTimeout(() => {
        this.cd.markForCheck();
      }, 1000);
    }

    // this.wpService.getMenu().subscribe((response) => {
    //   response.Data.sort((a, b) => {
    //     return a.order - b.order;
    //   });
    //   if (!this.userInfo.isCanon) {
    //     let responseData = [];
    //     response.Data.forEach((item, index) => {
    //       if (item.content != "Webinars") {
    //         responseData.push(response.Data[index]);
    //       }
    //     });
    //     this.inforWPMenus = responseData;
    //   } else this.inforWPMenus = [{
    //         "content": "Clubs",
    //         "contentNorway": "Photo clubs",
    //         "url": "/user/my-groups",
    //         "icon": "fa fa-users",
    //         "order": 5,
    //         "create_at": "2022-02-21T06:11:42.000Z",
    //         "id": 7
    //       }];
    // });
  }

  logout() {
    this.authService.logout().then(() => {
      this.router.navigate(["/login"]);
    });
  }

  search(term) {
    this.router.navigate(["/search/tag"], { queryParams: { key: term } });
  }

  redirectPage(accessLevel) {
    for (let i = 0; i < this.tagCollection.length; i++) {
      if (this.tagCollection[i]["value"].toUpperCase() === accessLevel) {
        this.hrefPage = this.tagCollection[i]["href"];
        break;
      }
    }
  }

  handleClass() {
    return this.router.url.includes("explore");
  }

  contactUs() {
    // const modalRef = this._modalService.open(MailPopupComponent, {
    //   centered: true,
    //   size: "lg",
    // });
    // modalRef.componentInstance.model = this.userInfo || {};
  }

  // goToShop($event) {
  //   $event.preventDefault();
  //   window.open("https://www.camerallashop.com", "_blank");
  // }
}
